import { updateNextAndPreviousBoothURL } from "../../helpers/updateNextAndPreviousBoothURL";
import { useRouterStore } from "../../store/useRouterStore";
import { useModelStore } from "../../store/useModelStore";
import { useThree } from "@react-three/fiber";
import { useEffect } from "react";
import Router, { useRouter } from "next/router";
import { animateToBooth } from "../../animations/animateToBooth";
import { animateHideBlackBanner } from "../../animations/animateBlackBanner";
import { closeStripes } from "../../animations/animateStripes";
import { useComponentLoadingStateStore } from "../../store/useComponentLoadingStateStore";
import { IBooth } from "../../store/interfaces/IBooth";
import { useMobileBrowser } from "../../hooks/useMobileBrowser";

const ChangeBoothFiberComponent = () => {
  const { isBoothModelMounted, setIsBoothModelMounted, isHallTextureReady } =
    useComponentLoadingStateStore();
  const { boothID, arrowDirection, lastTriggeredAt, boothClickTriggeredFrom } =
    useRouterStore();
  const { booths } = useModelStore();
  const { camera, scene } = useThree();
  const { pathname } = useRouter();
  const { isMobileBrowser } = useMobileBrowser();

  useEffect(() => {
    if (boothID === "" || booths.length <= 0) return;
    updateNextAndPreviousBoothURL(boothID, booths, arrowDirection);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastTriggeredAt, Router, arrowDirection]);

  useEffect(() => {
    const group = scene.getObjectByName(boothID);
    const isExpoPage = pathname.split("/")[1] === "expo";
    if (!isBoothModelMounted || !group || boothID === "") return;
    if (boothClickTriggeredFrom === "expo" || isExpoPage) {
      if (!isHallTextureReady) return;
      animateToBooth(
        camera,
        group.children[0] as unknown as IBooth,
        group.userData?.standSize,
        true,
        isMobileBrowser
      );
      animateHideBlackBanner();
    }
    if (boothClickTriggeredFrom === "global") {
      if (!isHallTextureReady) return;
      closeStripes(() => {
        animateToBooth(
          camera,
          group.children[0] as unknown as IBooth,
          group.userData?.standSize,
          true,
          isMobileBrowser
        );
      });
      animateHideBlackBanner();
    }
    setIsBoothModelMounted(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isBoothModelMounted,
    boothID,
    pathname,
    isHallTextureReady,
    isMobileBrowser,
  ]);
  return <mesh></mesh>;
};

export default ChangeBoothFiberComponent;
